<template>
  <div class="wrapper">
    <div class="container">
      <div class="tabs-slot-wrapper">
        <slot name="tabs" />
      </div>
      <div
        class="content"
        :style="{ minHeight: minHeight || undefined, height: height || undefined, }"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex"
import { defineComponent } from "vue"
export default defineComponent({
 name: "GenericSubPanel",
 components: {},
 props: {
  minHeight: {
    type: String,
    default: '',
  },
  height: {
    type: String,
    default: '',
  },
 },
setup() {
  const store = useStore();
  return {
    state: store.state,
  }
},
})
</script>

<style scoped>
.wrapper {
  position: relative;
  display: flex;
  /* justify-content: space-evenly; */
  flex-wrap: wrap;
  width: 100%;
  /* margin-top: 5px; */
}
.container {
  display: inline-block;
  width: 90%;
  height: 100%;
  margin: auto;
  background-color: var(--sub-panel-bg);
  border: var(--border-light);
  border-radius: 5px;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
}
.content {
  margin: 0px 0 4px 0;
}
.tabs-slot-wrapper {
  margin: 3px 0px;
}
</style>